import Swiper, {Navigation, Pagination} from "swiper";
import "swiper/scss";

class BusinessSlider {
    constructor() {

        this.texts = document.querySelectorAll(".rec-item__content");



        Swiper.use([Navigation, Pagination]);

        this.newsSlider = new Swiper('.recommendations', {
            direction: "horizontal",
            scrollbar: false,
            slidesPerView: 1,
            loop: false,
            navigation: {
                prevEl: ".rec-slider-prev",
                nextEl: ".rec-slider-next"
            },
            pagination: {
                el: ".rec-slider-dots",
                type: "bullets",
                bulletElement: "div",
                bulletClass: "rec-slider-dots__dot",
                bulletActiveClass: "rec-slider-dots__dot--active",
                clickable: true,
            }
        })
        this.texts.forEach((el) => {
            let txt = el.querySelector(".rec-item__content-txt");
            if (txt.innerText.length > 150) {
                txt.classList.add("hidden")
                let expandEl = document.createElement("span");
                expandEl.innerText = "Rozwiń"
                expandEl.classList.add("default-anchor")
                el.appendChild(expandEl);
                expandEl.addEventListener("click", (e)=>{
                    if(!txt.classList.contains('hidden')){
                        txt.classList.add('hidden')
                        expandEl.innerText = "Rozwiń";

                    }else{
                        txt.classList.remove('hidden')
                        expandEl.innerText = "Zwiń";
                    }


                })
            }


        })

        this.newsSlider.on('slideChange', ()=>{
            this.texts.forEach((el) => {
                let expandEl = el.querySelector(".default-anchor");
                let txt = el.querySelector(".rec-item__content-txt");
                if(!txt.classList.contains('hidden')){
                    txt.classList.add('hidden')
                    expandEl.innerText = "Rozwiń";

                }
            })
        })
    }

    events() {

    }
}

export default BusinessSlider;